<template>
  <!-- ETL run status 색상 배지 — 색상 + 아이콘 + 텍스트 3중 표현 (WCAG 2.1 AA) -->
  <span
    class="run-status-badge"
    :style="{ color: statusColor }"
    :aria-label="statusLabel"
    role="status"
  >
    <component :is="statusIcon" v-if="showIcon" :spin="value === 'running'" style="margin-right: 4px;" />
    <span>{{ statusLabel }}</span>
  </span>
</template>

<script>
// @MX:SPEC: SPEC-ECOUNT-ETL-OPS-CONSOLE-001 REQ-OC-RUNS-003 (ux-patterns.md §11.7, §7.2)
import {
  LoadingOutlined,
  CheckCircleOutlined,
  WarningOutlined,
  CloseCircleOutlined,
  MinusCircleOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons-vue';

// status → 색상 매핑 (ux-patterns.md §7.2)
const STATUS_COLOR_MAP = {
  running: '#1890ff',
  success: '#52c41a',
  partial: '#fa8c16',
  failed: '#f5222d',
  cancelled: '#8c8c8c',
};

const STATUS_ICON_MAP = {
  running: LoadingOutlined,
  success: CheckCircleOutlined,
  partial: WarningOutlined,
  failed: CloseCircleOutlined,
  cancelled: MinusCircleOutlined,
};

export default {
  name: 'RunStatusBadge',
  components: {
    LoadingOutlined,
    CheckCircleOutlined,
    WarningOutlined,
    CloseCircleOutlined,
    MinusCircleOutlined,
    QuestionCircleOutlined,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    statusColor() {
      return STATUS_COLOR_MAP[this.value] || '#8c8c8c';
    },
    statusIcon() {
      return STATUS_ICON_MAP[this.value] || QuestionCircleOutlined;
    },
    statusLabel() {
      // 기술 용어는 영문 원문 유지 (ux-patterns.md §10.3)
      return this.value || '-';
    },
  },
};
</script>

<style scoped>
.run-status-badge {
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  font-size: 13px;
}
</style>
